import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
import { XIcon } from 'lucide-react';
import { trackInitiateCheckout } from './MetaPixel';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    // Show after 3 seconds of page load
    const timer = setTimeout(() => {
      if (!isDismissed) {
        setIsVisible(true);
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [isDismissed]);
  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
  };
  const handleGetStarted = () => {
    trackInitiateCheckout();
    window.open('https://buy.stripe.com/7sY7sM4gh69WcVo3vJdnW07', '_blank');
  };
  return <AnimatePresence data-id="element-116">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-[var(--jet-black)] border-t-4 border-[var(--viridia-green)] shadow-2xl" data-id="element-117">
          <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-4" data-id="element-118">
            <div className="flex-grow" data-id="element-119">
              <p className="text-white font-bold text-lg" data-id="element-120">
                Stop losing estimates to slow replies
              </p>
              <p className="text-gray-400 text-sm" data-id="element-121">
                $497 setup fee waived • Live in 48-72 hours
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-122">
              <Button size="md" onClick={handleGetStarted} data-id="element-123">
                Buy Now - $297/mo
              </Button>
              <button onClick={handleDismiss} className="text-gray-400 hover:text-white transition-colors p-2" aria-label="Dismiss" data-id="element-124">
                <XIcon className="w-5 h-5" data-id="element-125" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}